import { NewsService } from "@/api";

// state
const state = () => ({
  all: [],
  title: "",
});

// getters
const getters = {};

// actions
const actions = {
  async getAll({ commit }) {
		const resp = await NewsService.getAll();
    const { news, title } = resp;

    commit("setAll", news);
    commit("setTitle", title);
  },
};

// mutations
const mutations = {
  setAll(state, news) {
    state.all = news;
  },
  setTitle(state, news) {
    state.title = news;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
